module.exports = __webpack_public_path__ + "img/logouni12.45cb9dfc.png";